<template>
  <td
    :rowspan="rowspan"
    class="boss-table-data"
  >
    <div
      v-for="(id, i) in photoclipIds"
      :key="`photoclip-${i}`"
      class="pega-mb-05"
      data-test="photoclip-preview-button"
    >
      <button
        class="boss-button"
        :data-test="`photoclip-preview-button-${i}`"
        @click="windowOpenPreview('photoClipPrePublishedPreview', id)"
      >
        フォトクリップ
      </button>
    </div>
    <div
      v-for="(id, i) in interviewIds"
      :key="`interview-${i}`"
      class="pega-mt-05"
      data-test="interview-preview-button"
    >
      <button
        class="boss-button"
        :data-test="`interview-preview-button-${i}`"
        @click="windowOpenPreview('interviewPrePublishedPreview', id)"
      >
        インタビュー
      </button>
    </div>
  </td>
</template>

<script>
export default {
  props: {
    rowspan: {
      type: Number,
      required: true
    },
    photoclipIds: {
      type: Array,
      required: true
    },
    interviewIds: {
      type: Array,
      required: true
    }
  },
  methods: {
    windowOpenPreview (name, id) {
      const routeData = this.$router.resolve({ name: name, params: { id: id } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
